<template>
  <div class="my-property-component">
    <div class="property-info-wrap">
      <div class="balance-info">
        <div class="title">我的余额</div>
        <div class="balance-num">￥{{ user.balance || 0 }}</div>
        <div class="btn-list">
          <router-link class="btn flex-cc" :to="{ path: '/recharge/user' }">充值</router-link>
          <!-- <router-link class="btn flex-cc" :to="{ path: '/withdraw/index' }">提现</router-link> -->
          <router-link class="btn flex-cc" :to="{ path: '/balance/user' }">详情</router-link>
        </div>
      </div>
      <div class="balance-info credit-deposit">
        <div class="title">我的信用金</div>
        <div class="balance-num">￥{{ user.credit_deposit || 0.00 }}</div>
        <div class="btn-list">
          <!-- <router-link class="btn flex-cc" :to="{ path: '/repayment/user' }">还款</router-link> -->
          <router-link class="btn flex-cc" :to="{ path: '/credit_deposit/user' }">详情</router-link>
        </div>
      </div>
    </div>
    <div class="order-card">
      <div class="order-tab">
        <div class="tabs">
          <div @click="changeTab('daichuli')" :class="['item', { 'active': listQuery.status == 'daichuli' }]">待处理订单<span
              class="num">{{
          status0 || 0 }}</span></div>
          <div @click="changeTab('daihuankuan')" :class="['item', { 'active': listQuery.status == 'daihuankuan' }]">
            待还款订单<span class="num">{{
          status1 || 0 }}</span></div>
        </div>

      </div>
      <div class="table-wrap">
        <el-button v-if="listQuery.status == 'daihuankuan'" :disabled="checkList.length == 0"
          @click="handleMultiRepayment" class="my-btn">批量还款</el-button>
        <el-table class="xm-table" :data="list" v-loading="loading" element-loading-text="给我一点时间"
          :empty-text="emptyText" fit highlight-current-row>
          <el-table-column label="订单信息" align="center" minWidth="400">
            <template slot="header" slot-scope="scope">
              <div class="flex-row">
                <div class="flex-grow-0 mgl10" v-if="listQuery.status == 'daihuankuan'">
                  <el-checkbox v-model="checkAll" @change="handleCheckAll">全选</el-checkbox>
                </div>
                <div class="flex-grow-1">订单信息</div>
              </div>
            </template>
            <template slot-scope="{row}">
              <div class="row01 flex-row">
                <div class="flex-grow-0 mgl10" v-if="listQuery.status == 'daihuankuan'">
                  <el-checkbox v-model="row.checked" @change="handleCheck(row)">
                  </el-checkbox>
                </div>
                <div class="flex-grow-1 mgl10 tal">订单号：{{ row.order_no }} </div>
                <div class="flex-grow-0">时间：{{ row.create_time }}</div>
              </div>
              <div class="row002" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <div class="flex-col goods" v-for="(goods, index) in row.product" :key="index">
                  <div class="flex-row mgt10 mgl10 tal">
                    <div class="flex-grow-0 mgr10">
                      <el-image style="width: 70px;height: 70px;" :src="goods.cover"></el-image>
                    </div>
                    <div class="flex-grow-1 flex-col">
                      <div class="name flex-row">
                        <div class="flex-grow-1">{{ goods.name }}</div>
                        <div class="flex-grow-0 mgr10" v-if="row.team_id">
                          <el-tooltip class="item" effect="dark" :content="row.team_name" placement="top">
                            <span class="colorBlue">团队订单</span>
                          </el-tooltip>
                        </div>
                      </div>
                      <div class="desc">
                        <span>×{{ goods.num }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金额" align="center" width="120">
            <template slot-scope="{row}">
              <div class="row01">
              </div>
              <div class="row02 flex-xy-center flex-col"
                :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <span>￥{{ row.pay_amount }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="{row}">
              <div class="row01">
              </div>
              <div class="row02 flex-xy-center" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <span style="color:#FF8F1F;">{{ row.status_name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" width="120">
            <template slot-scope="{row}">
              <div class="row01">
              </div>
              <div class="row02 flex-xy-center flex-col"
                :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <p>{{ row.remark }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">
            <template slot-scope="{row}">
              <div class="row01">
              </div>
              <div class="row02 flex-xy-center flex-col"
                :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <template v-if="row.repayment_pay_id == 0 && row.credit_deposit_amount > 0">
                  <el-link :underline="false" @click="handleRepayment(row)">去还款</el-link>
                </template>
                <template v-if="row.status == 10 && row.pay_amount > 0">
                  <el-link :underline="false" @click="handlePay(row)">去付款</el-link>
                </template>
                <el-link :underline="false" @click="handleDetail(row)">查看详情</el-link>
                <!-- <el-link :underline="false" @click="handleCancel(row)">取消</el-link> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex-row mgt20">
          <div class="flex-grow-1"></div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from "@/api/user";
import { getOrderList, getOrderStatCount, setShip } from "@/api/order";
export default {
  name: 'UserIndex',
  components: {

  },
  data() {
    return {
      loading: false,
      emptyText: '暂无数据',
      activeTab: 0,
      user: {},
      tableRowHeight: 90,
      status: 0,
      emptyText: '暂无数据',
      listQuery: {
        status: 'daichuli',
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
      status0: 0,
      status1: 0,
      tableRowHeight: 90,
      checkList: [],
      checkAll: false,
    };
  },
  computed: {

  },
  created() {
    this.getInfo();
    this.getOrderStatCount();
    this.getList();
  },
  methods: {
    handleCheckAll(val) {
      // console.log(val)
      this.list.forEach((item) => {
        item.checked = val;
      });
      this.handleCheck();
    },
    handleCheck() {
      this.checkList = this.list.filter((item) => {
        return item.checked;
      }).map((item) => {
        return item.id;
      });
      // console.log(this.checkList)
      if (this.checkList.length == this.list.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    getInfo() {
      getInfo({}).then(res => {
        this.loading = false;
        this.user = res.data;
      }).catch((err) => {

      });
    },
    changeTab(status) {
      this.listQuery.status = status
      this.getList()
    },
    getOrderStatCount() {
      getOrderStatCount({}).then((response) => {
        this.status0 = response.data.status0 * 1;
        this.status1 = response.data.status1 * 1
      }).catch(() => {
        this.loading = false;
      });
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      if (_listQuery.status == 'daichuli') {
        _listQuery.status = '10,21'
        _listQuery.repayment_pay_id = null
      } else {
        _listQuery.status = null
        _listQuery.repayment_pay_id = '0'
      }
      getOrderList(_listQuery)
        .then((response) => {
          this.list = response.data.list.map((item, index) => {
            item.checked = false;
            return item;
          });
          this.total = response.data.count * 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    // 上一页
    handlePrevPage() {
      let page = this.listQuery.page;
      if (page - 1 > 1) {
        page--
      }
      this.listQuery.page = page;
      this.getList();
    },
    // 下一页
    handleNextPage() {
      let page = this.listQuery.page;
      if ((this.total / this.listQuery.pagesize) > page + 1) {
        page++
      }
      this.listQuery.page = page;
      this.getList();
    },
    clipboardSuccess() {
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    // 取消订单
    handleCancel(order) {
      this.$confirm('确定要取消订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        cancelOrder({
          id: order.id
        })
          .then((response) => {
            this.loading = false;
            this.getList();
            this.$message({
              type: 'success',
              message: '取消成功!'
            });
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    // 去还款
    handleRepayment(order) {
      this.$router.push({
        path: '/repayment/user',
        query: {
          id: order.id,
        }
      });
    },
    //批量还款
    handleMultiRepayment() {
      if (this.checkList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择还款订单'
        });
        return false;
      }
      this.$router.push({
        path: '/repayment/user',
        query: {
          id: this.checkList.join(','),
        }
      });
    },
    // 去支付
    handlePay(order) {
      this.$router.push({
        path: '/cashier',
        query: {
          order_id: order.id,
          type: 0,
        }
      });
    },
    // 查看详情
    handleDetail(order) {
      this.$router.push({
        path: '/user/order/detail',
        query: {
          id: order.id
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.my-property-component {
  width: 100%;
  margin-top: 16px;

  .property-info-wrap {
    width: 100%;
    padding: 32px 50px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    display: grid;
    grid-template-columns: 352px auto;

    .balance-info {
      width: 100%;

      .title {
        font-size: 16px;
        font-weight: 400;
        color: #6F7F84;
        margin-bottom: 10px;
      }

      .balance-num {
        font-size: 20px;
        font-weight: 400;
        color: #FABE2A;
        margin-bottom: 18px;
      }

      .btn-list {
        display: flex;
        align-items: center;
        column-gap: 13px;

        .btn {
          width: 81px;
          height: 39px;
          border-radius: 0;
          border: 1px solid #A0A9AC;
          font-size: 16px;
          font-weight: 400;
          color: #A0A9AC;
        }
      }
    }

    .credit-deposit {
      width: 100%;
      padding-left: 59px;
      border-left: 1px solid #CCD7DB;

      .title {
        color: #222222;
      }
    }
  }

  .order-card {
    width: 100%;
    margin-top: 16px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    padding-bottom: 20px;

    .order-tab {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #CCD7DB;
      padding: 19px 25px 0 25px;
      box-sizing: border-box;

      .tabs {
        display: flex;
        align-items: center;
        column-gap: 60px;
        width: 100%;

        .item {
          font-size: 16px;
          font-weight: 400;
          color: #222222;
          padding-bottom: 11px;
          cursor: pointer;

          .num {
            color: #00B4E8 !important;
            margin-left: 5px;
          }
        }

        .active {
          color: #00B4E8 !important;
          border-bottom: 2px solid #00B4E8 !important;
        }
      }

      .order-manager {
        width: 70px;
        font-size: 16px;
        font-weight: 400;
        color: #222222;
        padding-bottom: 11px;
        cursor: pointer;
      }

      .order-manager-active {
        color: #00B4E8 !important;
        border-bottom: 2px solid #00B4E8 !important;
      }
    }

    .table-wrap {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      // align-items: center;
      padding: 29px 24px 20px 24px;
      box-sizing: border-box;

      .table {
        border: 1px solid #DCE5EB;
      }

      th {
        text-align: center;
        padding: 13px 0;
      }

      thead {
        tr {
          th {
            background-color: #E9F3F6;
          }

          th:nth-child(1) {
            font-size: 16px;
            font-weight: 400;
            color: #222222;

            i {
              color: #6F7F84;
            }
          }

          th:nth-child(2),
          th:nth-child(3),
          th:nth-child(4) {
            width: 120px;
          }

          th:nth-child(5) {
            width: 170px;
          }
        }
      }

      tbody {
        .name-th {
          width: 100%;
          display: flex;
          align-items: center;
          column-gap: 10px;
          padding-left: 30px;
          box-sizing: border-box;

          &>img {
            width: 75px;
            height: 75px;
          }
        }

        .pay-btn {
          width: 90px;
          height: 30px;
          background: #00B4E8;
          border-radius: 15px;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          margin: 0 auto;
        }

        tr {
          th {
            p {
              margin: 5px 0;
              cursor: pointer;
            }
          }
        }

        th:not(:last-child) {
          border-right: 1px solid #DCE5EB;
        }

        tr:not(:last-child) {
          border-bottom: 1px solid #DCE5EB;
        }

        &>.empty {
          position: relative;
          height: 43px;

          &>th {
            position: absolute;
            width: 100%;
            height: 43px;
            font-size: 15px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
